import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import * as PIXI from "pixi.js";

export class OnceCallbackContinueButton extends ContinueButton {

    private _onceClickCallback: Function | null;

    public addOnceClickCallback(callback: Function): void {
        this._onceClickCallback = callback;
    }

    protected onClick(event?: PIXI.InteractionEvent): void {
        if (this._onceClickCallback) {
            this._onceClickCallback();
            this._onceClickCallback = null;
        }

        super.onClick(event);
    }
}
